import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { getFrontFileUrl } from "../../services/apiFront";

export default function ValidationMemoireDistric() {
  const [memoires, setMemoires] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [comments, setComments] = useState({});

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await api.get("/memoireValidation/district");
        const rows = (res.data || []).filter(m => (m.status ?? "en_attente") === "en_attente");
        setMemoires(rows);
        setErr("");
      } catch (e) {
        console.error("Erreur chargement mémoires (district) :", e);
        setErr("Impossible de charger les mémoires.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleChangeComment = (id, value) => {
    setComments(prev => ({ ...prev, [id]: value }));
  };

  const handleValidation = async (id, status) => {
    try {
      const apiStatus = status === 1 ? "valide" : "refuse";
      const comment = comments[id]?.trim() || null;

      if (apiStatus === "refuse" && !comment) {
        return alert("Merci d'ajouter un commentaire pour le refus.");
      }

      await api.patch(`/memoireValidation/${id}/validate`, { status: apiStatus, comment });

      setMemoires(prev => prev.filter(m => m.id !== id));
      setComments(prev => {
        const clone = { ...prev };
        delete clone[id];
        return clone;
      });
    } catch (err) {
      console.error("Erreur lors de la mise à jour:", err?.response || err);
      alert("Erreur lors de la mise à jour");
    }
  };

  return (
    <div className="card shadow border-0 mb-4">
      <div className="card-header">
        <h5 className="mb-0">Validation des mémoires (District)</h5>
      </div>

      <div className="card-body">
        {loading && <p className="text-muted mb-0">Chargement…</p>}
        {err && <div className="alert alert-danger">{err}</div>}

        {!loading && !err && (
          <>
            {memoires.length === 0 ? (
              <p className="text-muted mb-0">Aucun mémoire en attente.</p>
            ) : (
              <ul className="list-unstyled mb-0">
                {memoires.map((m) => (
                  <li key={m.id} style={styles.item} className="mb-3">
                    <div className="fw-semibold mb-1">
                      <i className="bi bi-person me-2"></i>
                      Élève : {m.aspirant_name || "—"}
                    </div>

                    <div className="mb-2">
                      <a
                        href={getFrontFileUrl(m.file_path)}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-secondary"
                      >
                        Voir mémoire
                      </a>
                      {m.title ? <span className="ms-2 text-muted">({m.title})</span> : null}
                    </div>

                    <div className="mb-2">
                      <label className="form-label mb-1">Commentaire</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        placeholder="Ex: Document incomplet, manque la signature…"
                        value={comments[m.id] || ""}
                        onChange={(e) => handleChangeComment(m.id, e.target.value)}
                      />
                    </div>

                    <div>
                      <button
                        onClick={() => handleValidation(m.id, 1)}
                        className="btn btn-success btn-sm me-2"
                        style={styles.valid}
                      >
                        Valider
                      </button>
                      <button
                        onClick={() => handleValidation(m.id, 0)}
                        className="btn btn-danger btn-sm"
                        style={styles.refuse}
                      >
                        Refuser
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  item: {
    background: "#f9f9f9",
    padding: "1rem",
    borderRadius: "8px",
  },
  valid: {
    minWidth: 110,
  },
  refuse: {
    minWidth: 110,
  },
};
